var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createSelector } from "@reduxjs/toolkit";
import { CameraViewId } from "3d/types";
export var selectUIRoot = function (state) { return state.ui; };
export var selectSelectionFilter = function (state) {
    return selectUIRoot(state).selectionFilter;
};
export var selectSelection = function (state) {
    return selectUIRoot(state).selection;
};
/* Stable empty result so "nothing selected" doesn't re-render every consumer. */
var noSelectedIds = [];
export var selectSelectedIds = function (state) {
    var selection = selectSelection(state);
    return (selection === null || selection === void 0 ? void 0 : selection.kind) === "entities" ? selection.ids : noSelectedIds;
};
export var selectSelectedId = function (state) {
    return selectSelectedIds(state)[0];
};
export var selectSelectedBoxId = function (state) {
    var selection = selectSelection(state);
    return (selection === null || selection === void 0 ? void 0 : selection.kind) === "box" ? selection.id : undefined;
};
export var selectIsGripFrameSelected = function (state) { var _a; return ((_a = selectSelection(state)) === null || _a === void 0 ? void 0 : _a.kind) === "gripFrame"; };
export var selectDraggedAttachmentId = function (state) {
    return selectUIRoot(state).draggedAttachmentId;
};
export var selectHoveredAttachmentId = function (state) {
    return selectUIRoot(state).hoveredAttachmentId;
};
export var selectHighlightedNodeIds = function (state) {
    return selectUIRoot(state).highlightedNodeIds;
};
export var selectCameraViewId = function (state) {
    return selectUIRoot(state).cameraViewId;
};
export var selectOverlayData = function (state) {
    return selectUIRoot(state).overlayData;
};
export var selectShowPsEsIndicators = function (state) {
    return selectUIRoot(state).showPsEsIndicators;
};
export var selectActiveMenuItem = function (state) {
    return selectUIRoot(state).activeMenuItem;
};
export var selectIs3DLoading = function (state) {
    return selectUIRoot(state).is3DLoading;
};
export var selectUnitSystem = function (state) {
    return selectUIRoot(state).unitSystem;
};
export var selectIsGraphPanelOpen = function (state) {
    return selectUIRoot(state).isGraphPanelOpen;
};
export var selectIsGraphPanelAutoOpened = function (state) {
    return selectUIRoot(state).isGraphPanelAutoOpened;
};
export var selectChecklist = function (state) {
    return selectUIRoot(state).checklist;
};
export var selectActiveSidebarItemID = function (state) {
    return selectUIRoot(state).activeSidebarItemID;
};
export var selectHasPendingSanityCheck = function (state) {
    return selectUIRoot(state).hasPendingSanityCheck;
};
export var selectActiveLayer = function (state) {
    return selectUIRoot(state).activeLayer;
};
export var selectCupFill = function (state) { return selectUIRoot(state).cupFill; };
export var selectSortedChecklist = createSelector(selectChecklist, function (checklist) {
    return Object.entries(checklist)
        .filter(function (_a) {
        var _b = __read(_a, 2), _itemName = _b[0], item = _b[1];
        return !item.hidden;
    })
        .sort(function (a, b) {
        var checklistItemA = a[1];
        var checklistItemB = b[1];
        if (!checklistItemA.completed && checklistItemB.completed) {
            return 1;
        }
        if (checklistItemA.completed && !checklistItemB.completed) {
            return -1;
        }
        return 0;
    });
});
export var selectNextChecklistStepIndex = createSelector(selectSortedChecklist, function (sortedChecklist) {
    return sortedChecklist.findIndex(function (_a) {
        var _b = __read(_a, 2), _id = _b[0], item = _b[1];
        return !item.completed;
    });
});
export var selectIsZoomedIn = function (nodeId) {
    return createSelector(selectSelectedIds, selectCameraViewId, function (selectedIds, cameraViewId) {
        return selectedIds.includes(nodeId) && cameraViewId === CameraViewId.NODE_VIEW;
    });
};
export var selectIsMultiSelecting = createSelector(selectSelectedIds, function (selectedIds) { return selectedIds.length > 1; });
